import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69c7c96b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "game" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Game Over", -1))


import GridPresenter from "@/components/GridPresenter.vue";
import GameInfoPresenter from "@/components/GameInfoPresenter.vue";
import PlayerInfoPresenter from "@/components/PlayerInfoPresenter.vue";
import GameOverDialogPresenter from "@/components/GameOverDialogPresenter.vue";

type Props = {
  isGameOver: boolean;
  isLocalGame: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GameView',
  props: {
    isGameOver: { type: Boolean },
    isLocalGame: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!__props.isLocalGame)
        ? (_openBlock(), _createBlock(PlayerInfoPresenter, {
            key: 0,
            class: "flex-grow-0 flex-shrink-1"
          }))
        : _createCommentVNode("", true),
      _createVNode(GridPresenter, { class: "flex-grow-0 flex-shrink-0" }),
      _createVNode(GameInfoPresenter, { class: "flex-grow-0 flex-shrink-1" })
    ]),
    _createVNode(_component_v_dialog, {
      width: "500",
      transition: "dialog-bottom-transition"
    }, {
      activator: _withCtx(({ props }) => [
        (__props.isGameOver)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createTextVNode("Show Results")
                ]),
                _: 2
              }, 1040)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(GameOverDialogPresenter)
      ]),
      _: 1
    })
  ]))
}
}

})